import SearchInput from "./SearchInput";
import { cleanFilteredList } from "./SearchInput";
const StaticText = ({
  textArray,
  inputArray,
  keywordsData,
  setPlaceholdersValues,
  setLiveTextIndex,
  setDisplayTriggerInput,
}) => {
  function handleSetLiveTextIndex() {
    setLiveTextIndex("prev");
  }

  return textArray.map((text, index) => {
    return (
      <div className="dss-static-text-wrapper" key={index}>
        <span className="dss-static-text-part">{text}</span>
        <SearchInput
          placeholder={Object.values(inputArray)[index]}
          placeholderKey={Object.keys(inputArray)[index]}
          setPlaceholdersValues={setPlaceholdersValues}
          keywordsList={cleanFilteredList(
            keywordsData[Object.keys(inputArray)[index]]
          )}
          setLiveTextIndex={handleSetLiveTextIndex}
          setDisplayTriggerInput={setDisplayTriggerInput}
        />
      </div>
    );
  });
};

export default StaticText;
